import React from 'react'
import { type PredefinedCrossClientQuery } from '../../../../models/CrossClient'
import { useAppSelector } from '../../../../store/hooks'
import { selectCrossClientInitLoading } from '../../../../store/crossClient/crossClientLanding'
import { CrossClientRowSkeleton } from '../CrossClientRowSkeleton'
import { CrossClientEmptyState } from '../CrossClientEmptyState'
import { CrossClientPredefinedQueryItem } from './CrossClientPredefinedQueryItem'
import './CrossClientLandingPredefinedQueries.scss'

export interface CrossClientLandingPredefinedQueriesProps {
  queries: PredefinedCrossClientQuery[]
  loading: boolean
  isError: boolean
  onSelect: (predefinedQuery: PredefinedCrossClientQuery) => void
  runDisabled?: boolean
}

export const CrossClientLandingPredefinedQueries: React.FC<CrossClientLandingPredefinedQueriesProps> = ({
  queries,
  loading,
  isError,
  onSelect,
  runDisabled,
}) => {
  const initLoading = useAppSelector(selectCrossClientInitLoading)

  if (loading) {
    return <CrossClientRowSkeleton count={6} />
  }

  if (isError) {
    return <CrossClientEmptyState message="Couldn't load recommended queries. Please try again." />
  }

  if (!queries.length) {
    return <CrossClientEmptyState message='No recommended queries' />
  }

  return (
    <div className='d-grid gap-3 align-items-start w-100 cross-client-predefined-grid'>
      {queries.map((item) => (
        <CrossClientPredefinedQueryItem
          key={item.id}
          predefinedQuery={item}
          bodyText={item.description}
          layout='card'
          initLoading={initLoading}
          runDisabled={runDisabled}
          onClick={onSelect}
        />
      ))}
    </div>
  )
}
